import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { Sector } from 'graphql-common';
import { SelectOption } from '@lib/components/Select/types';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import SectorChip from '@lib/components/SectorChip/SectorChip';
import styles from '../Select.module.scss';

function SectorOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti, options } = restProps;
  const value = _get(restProps, 'value', '');
  const selectedOption = _find(
    options,
    ({ value: optionValue }) => value === optionValue,
  ) as SelectOption;
  const sector = (_get(selectedOption, 'data') as Sector) ?? {
    name: _get(selectedOption, 'label'),
    color: _get(selectedOption, 'color'),
  };
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(styles.entityOptionChip, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <div className={styles.entityOptionChipContent}>
        <SectorChip sector={sector} />
      </div>
    </DefaultSelectComponents.Option>
  );
}

export default SectorOption;
